import * as React from 'react';
import { formatErrors } from '../utils/request';

type FetchState = {
  data: unknown;
  status: FetchAction['type'];
  error: { config: any; status: string | number; message: string } | null;
};

type FetchAction = {
  type: 'IDLE' | 'LOADING' | 'RESOLVED' | 'REJECTED';
  data: unknown;
  error: { config: any; status: string | number; message: string } | null;
};

function fetchReducer(state: FetchState, action: FetchAction): FetchState {
  switch (action.type) {
    case 'IDLE':
      return { ...state, status: 'IDLE' };
    case 'LOADING':
      return { ...state, status: 'LOADING' };
    case 'RESOLVED':
      return { ...state, status: 'RESOLVED', data: action.data };
    case 'REJECTED':
      return { ...state, status: 'REJECTED', error: action.error };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

function useFetchAsync() {
  const [state, dispatch] = React.useReducer(fetchReducer, {
    data: null,
    status: 'IDLE',
    error: null,
  });

  const run = React.useCallback((promise: Promise<unknown>) => {
    if (!promise) {
      return;
    }

    dispatch({ type: 'LOADING', data: null, error: null });

    promise.then(
      (response: unknown) => {
        dispatch({ type: 'RESOLVED', data: response, error: null });
      },
      (error: unknown) => {
        dispatch({ type: 'REJECTED', data: null, error: formatErrors(error) });
      },
    );

    // setTimeout(() => {
    //   promise.then(
    //     (response: unknown) => {
    //       dispatch({ type: 'RESOLVED', data: response, error: null });
    //     },
    //     (error: unknown) => {
    //       dispatch({
    //         type: 'REJECTED',
    //         data: null,
    //         error: formatErrors(error),
    //       });
    //     },
    //   );
    // }, 5000);
  }, []);

  return { ...state, run };
}

export default useFetchAsync;
